export default "__VITE_ASSET__27e89627__"